import { Directive, ElementRef, forwardRef, HostListener } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
  selector: '[portalFormInputNumber]',
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputNumberDirective),
      multi: true,
    },
  ],
})
export class InputNumberDirective implements ControlValueAccessor {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    let rawValue = input.value.replace(/,/g, ''); // Remove all commas

    // Allow only numbers and a single decimal point
    rawValue = rawValue.replace(/[^0-9.]/g, '');

    // Ensure only one decimal point is allowed
    const decimalParts = rawValue.split('.');
    if (decimalParts.length > 2) {
      rawValue = decimalParts[0] + '.' + decimalParts.slice(1).join('');
    }

    const numericValue = parseFloat(rawValue); // Convert to number

    if (isNaN(numericValue)) {
      input.value = ''; // Reset invalid input
      this.onChange(null);
      return;
    }

    // Format integer part with commas
    const parts = rawValue.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    input.value = parts.join('.'); // Update displayed value
    this.onChange(numericValue); // Emit numeric value to FormControl
  }

  @HostListener('blur')
  onBlur() {
    this.onTouched();
  }

  writeValue(value: number | null): void {
    if (value === null || isNaN(value)) {
      this.el.nativeElement.value = '';
      return;
    }

    const parts = value.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    this.el.nativeElement.value = parts.join('.');
  }

  registerOnChange(fn: (value: number | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  private onChange: (value: number | null) => void = () => {};

  private onTouched: () => void = () => {};
}
